import { render } from "./AppointmentForm.vue?vue&type=template&id=76224915"
import script from "./AppointmentForm.vue?vue&type=script&lang=js"
export * from "./AppointmentForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__